import '../css/main.scss';

if (module.hot) {
  module.hot.accept();
}
